module.exports = __webpack_public_path__ + "media/images/Twitter-aeede98e8193432f48cfa93965e20f57.png";